const CadrageBanner = ({projectName, projectStep, projectImage}) => {

    return(
        <>
            <section className="be-banner" style={{backgroundImage: `${projectImage} || 'url(/assets/images/banners/banner-cadrage.jpg)'`}}>
                <div className="">
                    <p className="be-banner-title">CHIFFRAGE : {projectName}</p>
                    <p className="be-centered-p">{projectStep}</p>
                </div>
            </section>
        </>
    )

}

export default CadrageBanner;